<template>
   <v-card
          width="200"
          height="100"
          class="pa-6 mr-10"
          :color="dashObject.bgcolor"
        >
          <v-row>
            <v-col cols="8" class="pa-0">
              <p class="text-start pa-0 text-h5" style="font-weight: 400">
                {{dashObject.name}}
              </p>
            </v-col>
            <v-col cols="4" class="pa-0">
              <p
                class="text-end text-h3 pa-0 black--text font-weight-bold"
                style="margin-top: 50%"
              >
               {{dashObject.number}}
              </p>
            </v-col>
          </v-row>
        </v-card>
</template>

<script>
import MySetting from "@/views/MySetting";
import { mapState } from "vuex";
const fb = require("../firebaseConfig.js");
export default {
  data: () => ({
  }),
  methods: {},
  props: {
    dashObject: {
      required: true,
    },
 
  },
};
</script>
